import { Component, OnInit } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { EventService } from '../service/event.service';
import { ShowErrorEvent, BeforeSubmitErrorEvent, ClientErrorEvent, DismissSnackBarEvent } from '../service/events';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { SnackBarErrorData } from '../model/af.model';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  standalone: false
})
export class ErrorComponent implements OnInit {

  serverError: boolean = false;
  errorMessage: string;
  actionButtonLabel = 'Close';
  ariaActionButtonLabel = 'close';
  action: boolean = true;
  setAutoHide: boolean = false;
  autoHide: number = 5000;
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  addExtraCLass: boolean = true;
  snackBarRef: MatSnackBarRef<SimpleSnackBar> | MatSnackBarRef<ErrorMessageComponent>;
  errorData: SnackBarErrorData;

  constructor(private eventBus: EventService, private _snackBar: MatSnackBar) {
  }

  ngOnInit() {

    let config = new MatSnackBarConfig();
    config.verticalPosition = this.verticalPosition;
    config.horizontalPosition = this.horizontalPosition;
    config.duration = this.setAutoHide ? this.autoHide : 0;
    config.panelClass = this.addExtraCLass ? ['server-error'] : undefined;

    let saveConfig = new MatSnackBarConfig();
    saveConfig.verticalPosition = this.verticalPosition;
    saveConfig.horizontalPosition = this.horizontalPosition;
    saveConfig.panelClass = this.addExtraCLass ? ['submit-error'] : undefined;
    saveConfig.duration = this.autoHide;

    // Setup errorData object to be passed to the custom snackbar component
    this.errorData = new SnackBarErrorData();
    this.errorData.action = this.action ? this.actionButtonLabel : undefined;
    this.errorData.ariaLabel = this.action ? this.ariaActionButtonLabel : undefined;

    this.eventBus.on(
      ShowErrorEvent,
      (event): void => {
        setTimeout(() => {
          if (event.payload.text.length > 0) {
            this.errorMessage = event.payload.text;
            /*
            Purpose is to condition off HTTP Status for duration
            Want to keep server errors / page validation errors open while setting duration to 5000 with 401s thrown by gwt (Login Page)
            Can expand this practice to say 422 (Unprocessed Entity with validation server errors) if we want to expand recognition
            with duration with page validations by setting return HTTP Status of 422 with these server errors
            */
            if (event.payload.text.length > 1000) {
              this.errorMessage = 'Error occurred in server .. ';
            }
            if (event.payload.httpStatus && (401 == event.payload.httpStatus)) {
              config.duration = 5000;
            } else if (event.payload.httpStatus && 1 == event.payload.httpStatus) {
              config.duration = 10000;
            } else {
              config.duration = this.setAutoHide ? this.autoHide : 0;
            }

            /*
            A custom component is used for this snackbar so the screen reader announces the correct message.
            First attempted to simply set the announcement message in the snackbar config but it led to the announcement 
            message and the snackbar message both being read.
            */
            this.errorData.errorMsg = this.errorMessage;
            config.data = this.errorData;
            this.snackBarRef = this._snackBar.openFromComponent(ErrorMessageComponent, config);
            this.focusCloseButton();
          } else {
            this.serverError = false;
            this.errorMessage = '';
            if (this.snackBarRef) {
              this.snackBarRef.dismiss();
            }

          }
        });
      }
    );

    this.eventBus.on(
      BeforeSubmitErrorEvent,
      (): void => {
        setTimeout(() => {
          this.errorMessage = 'The required fields below have not been entered correctly';
          this.errorData.errorMsg = this.errorMessage;
          saveConfig.data = this.errorData;
          this.snackBarRef = this._snackBar.openFromComponent(ErrorMessageComponent, saveConfig);
          this.focusCloseButton();
        });
      }
    );

    this.eventBus.on(
      ClientErrorEvent,
      (event): void => {
        setTimeout(() => {
          this.errorMessage = event.payload.text;
          this.errorData.errorMsg = this.errorMessage;
          saveConfig.data = this.errorData;
          this.snackBarRef = this._snackBar.openFromComponent(ErrorMessageComponent, saveConfig);
          this.focusCloseButton();
        });
      }
    );

    this.eventBus.on(
      DismissSnackBarEvent,
      (): void => {
        if (this.snackBarRef) {
          this.snackBarRef.dismiss();
        }
      }
    );
  }
  private focusCloseButton(): void {
    setTimeout(() => {
      const closeButton = document.querySelector('button[aria-label="close"]');
      if (closeButton) {
        (closeButton as HTMLElement).focus();
      }
    }, 0);
  }
}

